module.exports = __webpack_public_path__ + "static/media/avatar_default.aa2f1a83.svg";